<template>
  <div>
    <h2>Modificaciones a tarifa plana</h2>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <!--<small class="text-danger" v-if="!$v.rushHour.startHour.required">Campo requerido</small>-->
          <div class="row">
            <div class="col-md-7">
              <a-form-item label="Porcentaje de comisión de hora pico">
                <a-input
                  placeholder="Porcentaje de comisión de hora pico"
                  v-model="$v.rushHourCharge.$model"
                >
                <a-icon slot="addonAfter" type="percentage" />
                </a-input>
                <small class="text-danger" v-if="!$v.rushHourCharge.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.rushHourCharge.decimal">Campo decimal</small>
              </a-form-item>
            </div>
          </div>
          <div class="row" v-for="(rushHour, key) in $v.rushHour.$model" :key="key">
            <div class="col-md-3">
              <a-form-item label="Inicio de hora pico">
                <a-time-picker v-model="$v.rushHour.$model[key].startHour" :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChange" />
              </a-form-item>
              <small class="text-danger" v-if="!$v.rushHour.$each[key].startHour.required">Campo requerido. No debe estar vacío</small>
            </div>
            <div class="col-md-3">
              <a-form-item label="Fin de hora pico">
                <a-time-picker v-model="$v.rushHour.$model[key].endHour" :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm"></a-time-picker>
              </a-form-item>
              <small class="text-danger" v-if="!$v.rushHour.$each[key].endHour.required">Campo requerido. No debe estar vacío</small>
            </div>
            <div class="col-md-1">
              <a-button type="primary" @click="addRushHour">
                <a-icon type="plus-circle" />
              </a-button>
              <a-button v-if="key != 0" style="margin-left:5px" type="danger" @click="deleteFromRushHour(key)">
                <a-icon type="delete" />
              </a-button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <a-form-item>
                <b-button
                  :disabled="$v.$invalid"
                  block
                  type="submit"
                  class="btn px-5">
                  Registrar
                </b-button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <div>
      <a-table :columns="columns" :data-source="activeFare" bordered>
      </a-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import gql from 'graphql-tag'
import { required, decimal } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const _ = require('lodash')
const GET_ACTICVE_FARE = gql`
query getActiveFare{
  getActiveFare{
    rushHourCharge
    timeRange{
      startHour
      endHour
    }
  }
}
`
const UPDATE_RUSH_HOUR = gql`
  mutation updateRushHour($timeRange: [TimeRangeInput], $rushHourCharge: Float){
    updateRushHour(rushHour: { timeRange: $timeRange, rushHourCharge: $rushHourCharge }){
      appCharge
      distanceLessThanFour
      distanceMoreThanFour
      nightFare
      rushHourCharge
      startedPrice
      timeRange{
        startHour
        endHour
      }
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      rushHourCharge: '',
      rushHour: [{ startHour: '', endHour: '' }],
      activeFare: [],
      columns: [
        {
          title: 'Porcentaje de comisión de hora pico',
          dataIndex: 'rushHourCharge',
          key: 'rushHourCharge',
          customRender: (value, row, index) => {
            const obj = {
              children: value * 100,
              attrs: {},
            }
            return obj
          },
        },
        {
          title: 'Horas',
          dataIndex: 'timeRange',
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {},
            }
            // console.log(value)
            let hours = ''
            value.forEach(children => {
              // console.log(children)
              hours += '> Inicio: ' + children.startHour + ' Fin: ' + children.endHour + '  '
            })
            obj.children = hours
            return obj
          },
        },
      ],
    }
  },
  apollo: {
    getActiveFare: {
      query: GET_ACTICVE_FARE,
      context: headers(),
      result({ data }) {
        this.activeFare = []
        // const charge = data.getActiveFare.rushHourCharge
        // data.getActiveFare.rushHourCharge = data.getActiveFare.rushHourCharge * 100
        // console.log(charge * 100)
        this.activeFare.push(data.getActiveFare)
        // this.activeFare[0].rushHourCharge = charge * 100
        // console.log(this.activeFare)
      },
      error({ error }) {
        console.log(error)
      },
    },
  },
  methods: {
    displayTime(time) {
      return 'Inicio: ' + time.startHour
    },
    moment,
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
    handleSubmit() {
      let rushHours = []
      this.rushHour.forEach(range => {
        if (range.startHour && range.endHour) {
          rushHours.push({ startHour: moment(range.startHour).format('HH:mm'), endHour: moment(range.endHour).format('HH:mm') })
        }
      })
      rushHours = _.uniqWith(rushHours, _.isEqual)
      // console.log(rushHours)
      this.$apollo.mutate({
        mutation: UPDATE_RUSH_HOUR,
        context: headers(),
        variables: {
          rushHourCharge: parseFloat(this.rushHourCharge) / 100,
          timeRange: rushHours,
        },
      })
        .then(data => {
          // console.log(data)
          this.rushHour = [{ startHour: '', endHour: '' }]
          this.rushHourCharge = ''
          this.makeToast(true, 'success', 'Modificaion de tarifa plana', 'Se ha modificado la tarifa plana correctamente')
          this.$apollo.queries.getActiveFare.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    onChange(time, data) {
    },
    addRushHour() {
      this.rushHour.push({ startHour: '', endHour: '' })
    },
    deleteFromRushHour(key) {
      this.rushHour.splice(key, 1)
    },
  },
  validations: {
    rushHourCharge: { required, decimal },
    rushHour: {
      $each: {
        startHour: { required },
        endHour: { required },
      },
    },
  },
}
</script>
